import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../ConsultDoctor.module.css'
import * as api from '../../../services/ApiConsultDoctor'
import LoaderAnimation from '../../../components/LoaderAnimation'

import { notifyError } from "../../../components/NotifyToast";

import { Bar } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function ResultsUsingIoT ({ PID })
{
    //const location = useLocation()
    const [loading, setLoading] = useState(false)
    const [dataResult, setDataResult] = useState([])
    const [notData, setNotData] = useState('')

    // const [measureResult, setMeasureResult] = useState([])

    useEffect(() => {
        findResult()
    }, [PID])

    const findResult = async () => {
        setLoading(true)
        let res = await api.findHealthStationResult(PID)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setDataResult(res['data']['data'].sort(function (a, b) {
                    return Date.parse(a.created_date) - Date.parse(b.created_date)
                }))
            } else {
                setNotData(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const fieldInfo = {
        height: {label:"Height", units:"cm", low:0, ideal:0, high:0, min:0, max: 0},
        weight: {label:"Weight", units:"kg", low:0, ideal:0, high:0, min:0, max: 0},
        bmi: {label:"BMI", units:"", low:18, ideal:22, high:30, min:10, max: 55},
        sys: {label:"Systolic", units:"mmHg", low:90, ideal:105, high:130, min:40, max: 190},
        dia: {label:"Diastolic", units:"mmHg", low:60, ideal:70, high:80, min:40, max: 140},
        pulse: {label:"Pulse", units:"bpm", low:45, ideal:60, high:100, min:40, max: 135},
        temp: {label:"Temperature", units:"°C", low:33.5, ideal:36.5, high:39.5, min:30, max: 45},
        spo2: {label:"Oxygen Saturation", units:"%", low:80, ideal:100, high:120, min:60, max: 100}
    };

    const Chart = (props) => {

        const [barOptions, setBarOptions] = useState({});
        const [barData, setBarData] = useState({
            labels: [],
            datasets: []
        });

        const chartID = props.chartID;

        let chartDesc = fieldInfo[chartID].label;
        if (chartID !== "bmi")
        {
            if (chartID === "sys")
                chartDesc = "Blood Pressure: Systolic & Diastolic";

            chartDesc += " ("+fieldInfo[chartID].units+")";
        }

        useEffect(() =>
        {
            function prepGraphData(name)
            {
                const ideal = fieldInfo[name].ideal;
                const low = fieldInfo[name].low;
                const extreme = (fieldInfo[name].high + fieldInfo[name].max)/2;
                const rangeHigh = extreme - ideal;
                const rangeLow = ideal - low;

                const dataset = [];
                const listDates = [];
                const listValues = [];
                const listColors = [];

                let dataCount = dataResult.length;
                let count = 0;
                for (let i=0; i<dataCount; i++)
                {
                    const data = dataResult[i];
                    if (data[name] === "")
                        continue;
                    
                    const value = parseInt(data[name]);
                    if (value <= 0)
                        continue;

                    const thisTime = Date.parse(data.created_date);

                    let addNew = false;
                    if (count === 0)
                        addNew = true;
                    else {
                        const thisTime = Date.parse(data.created_date);
                        const lastTime = Date.parse(dataResult[i-1].created_date);
                        addNew = (thisTime-lastTime >= 3600000);
                    }

                    let hue = 0;
                    let col = "white";
                    if (extreme !== 0)
                    {
                        if (value >= ideal)
                            hue = Math.max(0,1 - ((value - ideal)/rangeHigh));
                        else hue = 1-Math.min(-(value - ideal)/rangeLow,1);
                    
                        col = "hsl("+(hue*120).toString()+",80%,50%,0.75)";
                    }
                    else col = "hsl(120,80%,50%,0.75)";

                    if (addNew)
                    {
                        dataset.push({ 'date': thisTime, 'value': value, 'color': { stroke: col } });

                        count++;
                        if (count === 10)
                            break;
                    }
                    else
                    {
                        const lastData = dataset[dataset.length-1];
                        lastData.date = thisTime;
                        lastData.value = value;
                        lastData.color.stroke = col;
                    }
                };

                dataset.forEach((data) => {
                    listDates.push(new Date(data.date).toLocaleDateString('en-GB').replaceAll('/','.'));
                    listValues.push(data.value);
                    listColors.push(data.color.stroke);
                });

                return {dates:listDates, data:listValues, colors:listColors};
            }

            let graphData = prepGraphData(chartID);
            barData.labels = graphData.dates;
            barData.datasets.push({label:chartID, data:graphData.data, backgroundColor:graphData.colors, grouped:false});

            if (chartID === "sys")
            {
                graphData = prepGraphData("dia");
                barData.datasets.push({
                    label:"dia",
                    data:graphData.data,
                    backgroundColor:graphData.colors.map((col) => {
                        return col.replace('50%,0.75','40%,1');
                    }),
                });
            }
            
            setBarData({
                labels:barData.labels,
                datasets:[...barData.datasets]
            });

            const labelSize = 14 - (barData.labels.length/10);
            const xSize = labelSize - (window.innerWidth < 512 ? 2 : 1);

            setBarOptions({
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                    datalabels: {
                        anchor: 'end',
                        font: { size: labelSize.toString() + '%' },
                        align: function(context) { return context.datasetIndex === 0 ? 'end' : 'start'; },
                        offset: function(context) { return context.datasetIndex === 0 ? -5 : 5; },
                        textStrokeWidth: function(context) { return context.datasetIndex === 0 ? 0 : 4; },
                        textStrokeColor: '#FFF',
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        suggestedMax: fieldInfo[chartID].max,
                        border: { display: false },
                        ticks: { font: { size: '12%' } },
                    },
                    x: {
                        border: { display: false },
                        grid: { display: false },
                        ticks: { font: {size: xSize.toString() + '%' } }
                    }
                }
            });

        }, [dataResult]);

        return (
            <Box sx={{
                display: 'grid',
                gridTemplateRows: '1fr 4fr',
                backgroundColor: '#FFFFFF',
                border: 2,
                borderColor: '#E3E9F2',
                borderRadius: 2,
                padding: 3,
            }}>
                <div align='center' justify='end'><b>{chartDesc}</b></div>
                <Box sx={{
                    display: 'inline',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Bar
                        options={barOptions}
                        data={barData}
                    />
                </Box>
            </Box>
        );
    };

    return (
        <>
            <LoaderAnimation loading={loading} />

            <Box sx={{
                textAlign: 'start',
                ml:2,
                color: '#082C91',
                fontSize: '24px',
                '@media (max-width: 512px)': { textAlign: 'center', }
            }}>
                ผลการคัดกรองสุขภาพ
            </Box>

            {notData === '' ?
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    alignContent: 'space-between',
                    gridGap: 20,
                    mt:2, mx:2,
                    color: '#082C91',
                    fontSize: 14,
                }}>
                    <Chart chartID='height' />
                    <Chart chartID='weight' />
                    <Chart chartID='bmi' />
                    <Chart chartID='sys' />
                    <Chart chartID='pulse' />
                    <Chart chartID='temp' />
                    <Chart chartID='spo2' />
                </Box>
                : 
                <div style={{ textAlign: 'center', margin: '20%', fontSize: 28 }}>ไม่พบข้อมูล</div>
            }
        </>
    )
}